import React from "react";
import { Card } from "pepsico-ds";
import "./HomePage.css";
import { useNavigate } from "react-router-dom";
const HomePage = () => {
  const navigate = useNavigate();
  const handleCKMSNavigation = () => {
    console.log("clicked");
    navigate("/spend-wise-hub");
  };
  return (
    <div className="homeContainer">
      <div className="$font-heading-h6-bold">
        What would you like to do today?
      </div>
      <div className="cardContainer">
        <div className="singleCard" onClick={handleCKMSNavigation}>
          <Card border ellipsis={false} icon="library_books">
            <div>
              <div className="$font-body-medium">
                Consulting Intake & Knowledge Management
              </div>
              <div className="$font-xsmall-regular">
                Submit requests and search for past engagements that might match
                your needs.
              </div>
            </div>
          </Card>
        </div>
      </div>
    </div>
  );
};
export default HomePage;
